import { Global } from "@emotion/react";
import React from "react";

import { makeStyles } from "../styles";
import { BaseDataResponseBody } from "../types";
import BusinessUserSettings from "./businessUserSettings";
import { Simplicity } from "./simplicity";
import { StyledWrapper, StyledContent, StyledTopbar, StyledOverlay } from "./styled";

const ShellNoBusinessUnit: React.FC<{
  businessUser: BaseDataResponseBody["businessUser"];
  hasAppError: boolean;
}> = ({ businessUser, hasAppError }) => {
  const [overlayVisibility, toggleOverlayVisibility] = React.useState<boolean>(false);
  const styles = makeStyles({ useSimplifiedLayout: true });

  return (
    <>
      <Global styles={styles.global.app} />
      <StyledWrapper styles={styles.appShell.wrapper} useSimplifiedLayout data-appshell="true">
        <StyledContent styles={styles.appShell.wrapper}>
          <StyledOverlay show={overlayVisibility} />
          <StyledTopbar id="navigation-topbar" withBackground={false}>
            <BusinessUserSettings
              hasLiveChatFeature={false}
              businessUser={businessUser}
              toggleOverlayVisibility={toggleOverlayVisibility}
              useSimplifiedLayout
              hasAppError={hasAppError}
              canViewBillingIngformation={false}
            />
          </StyledTopbar>
          <Simplicity />
        </StyledContent>
      </StyledWrapper>
    </>
  );
};

export default ShellNoBusinessUnit;
